import React, { useEffect, useState } from 'react';
import styles from '../css/ViewCount.module.css';

const ViewCount = ({ initialViews }) => {
  const [views, setViews] = useState(initialViews || 0);

  useEffect(() => {
    const fetchViews = async () => {
      try {
        const response = await fetch('https://dailycoinmarket.com/api/views');
        const data = await response.json();
        setViews(data.views || 0);
      } catch (error) {
        console.error('Error fetching views:', error);
      }
    };

    const incrementView = async () => {
      try {
        await fetch('https://dailycoinmarket.com/api/increment-view', {
          method: 'POST',
        });
        fetchViews();
      } catch (error) {
        console.error('Error incrementing view count:', error);
      }
    };

    incrementView();
    fetchViews();

    const interval = setInterval(fetchViews, 60000); // Fetch views every minute

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, []);

  // Function to format views in k if greater than or equal to 10000
  const formatViews = (views) => {
    if (views >= 10000) {
      return `${(views / 1000).toFixed(1)}k`; // Convert to thousands with one decimal place
    }
    return views ? views.toString() : '0'; // Return as-is if less than 10000, or '0' if undefined
  };

  return (
    <div className={styles.viewCountContainer}>
      <div className={styles.viewCountBox}>
        <h3>Current Views: {formatViews(views)}</h3>
      </div>
    </div>
  );
};

// Static Site Generation with Incremental Static Regeneration
export async function getStaticProps() {
  try {
    const res = await fetch('https://dailycoinmarket.com/api/views');
    const data = await res.json();

    return {
      props: {
        initialViews: data.views || 0,
      },
      revalidate: 60, // Regenerate the page every 60 seconds
    };
  } catch (error) {
    console.error('Error fetching initial views:', error);
    return {
      props: {
        initialViews: 0,
      },
    };
  }
}

export default ViewCount;
